export enum StorageType {
    FIELD = 1,
    STORAGE = 2,
}
